import { HTMLProps, memo } from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

export interface IListProps extends HTMLProps<HTMLDivElement> {
  children: JSX.Element | JSX.Element[] | undefined;
  title: string;
  vertical?: boolean;
  classes?: {
    listContainer?: string;
    listTitle?: string;
    listItems?: string;
  };
}

const List = ({ children, title, vertical = false, classes, ...rest }: IListProps ) => {
  return (
    <div className={classnames(styles.listContainer, classes?.listContainer)}>
      <div className={classnames(styles.listTitle, classes?.listTitle)}>{title}:</div>
      <div { ...rest } className={classnames(styles.listItems, classes?.listItems, vertical && styles.vertical)}>
        {children}
      </div>
    </div>
  );
};

export default memo(List);
